<template>
    <div class="search_wrapper desktop_search_wrapper lg:relative">
        <div class="relative">
            <button
                class="bg-gray-100 flex items-center bg-white text-gray-300 dark:text-gray-600 px-3 py-[0.4375rem] text-sm font-medium rounded-3xl w-[17.5rem] leading-4 h-[2.5rem]"
                :class="
                    isDesktop.screenSize.value == 'md' ||
                        isDesktop.screenSize.value == 'sm' ||
                        isDesktop.screenSize.value == 'xs'
                        ? 'hidden'
                        : ''
                "
                @click="openSearchMethod"
            >
                <fa :icon="['fal', 'search']" class="text-lg mr-1 text-grey-200 dark:text-gray-600" />
                <span v-if="appSearchString"> {{ appSearchString }}</span>
                <span v-else>Search</span>
            </button>
            <button
                v-if="
                    isDesktop.screenSize.value == 'md' ||
                        isDesktop.screenSize.value == 'sm' ||
                        isDesktop.screenSize.value == 'xs'
                "
                class="bg-gray-100 flex items-center text-gray-300 dark:text-gray-600 px-3 py-[0.4375rem] text-sm font-medium rounded-3xl leading-4 h-[2.5rem] w-[2.5rem]"
                :class="[
                    isDesktop.screenSize.value === 'sm' || isDesktop.screenSize.value == 'md' ? 'bg-white' : '',
                    isDesktop.screenSize.value === 'xs' ? 'bg-gray-100 hidden' : '',
                ]"
                @click="openSearchMethod"
            >
                <fa :icon="['fal', 'search']" class="text-lg text-grey-200 dark:text-gray-600" />
                <span class="xs:!hidden md:!hidden lg:block"> {{ appSearchString }}</span>
            </button>
            <span
                v-show="appSearchString.length > 0"
                class="cursor-pointer ml-auto absolute right-0 xs:!hidden md:!hidden lg:block px-4 py-2 z-10 top-0 text-gray-300"
                @click="clearSearch"
            >
                clear
            </span>
        </div>
        <!-- min-h-[41rem] -->
        <div
            v-show="dropSearch"
            ref="searchDropdown"
            class="search_results_wrapper absolute bg-white sm:left-[3%] sm:top-[4.9rem] lg:top-[3.125rem] md:left-[3%] lg:w-[45rem] sm:w-[calc(100%-6%)] lg:right-0 lg:left-[-27.5rem] shadow-search rounded-lg h-auto z-20"
            :class="isDesktop.screenSize.value == 'md' ? ' ' : 'w-[45.1875rem] top-12'"
        >
            <div
                class="search_input bg-white lg:max-w-[280px] m-auto mr-0 px-8 rounded-3xl py-2 bg-white-500 relative md:-top-12 mt-[-2px]"
            >
                <input
                    ref="globalSearchInput"
                    v-model="appSearchString"
                    type="text"
                    placeholder="Search"
                    class="w-full bg-white text-sm focus:outline-none"
                    @input="getResult(true)"
                />
                <div class="absolute py-[2px] right-0 top-0 text-gray-300 flex items-center">
                    <span
                        v-show="appSearchString.length > 0"
                        class="px-4 relative z-10 cursor-pointer"
                        @click="clearSearch"
                    >
                        clear
                        <fa :icon="['far', 'pipe']" />
                    </span>

                    <button class="text-xl pt-[4px] pr-[7px] text-gray-150" @click="closeSearchMethod">
                        <fa :icon="['fas', 'circle-xmark']" />
                    </button>
                </div>
            </div>
            <div class="search_drop p-6 -mt-9 rounded-t-3xl rounded-b-xl bg-white">
                <div class="flex items-center justify-between mb-6">
                    <Tabs
                        :tabs="searchTabsArray"
                        :current-tab="currentTab"
                        :wrapper-class="'search-tabs rounded max-w-max'"
                        :tab-class="'search-tabs__item'"
                        :tab-active-class="'search-tabs__item_active !rounded'"
                        item-classes="border-none h-8 !rounded"
                        @on-click="handleClick"
                    />
                    <!-- {{ searchTabsArray }} -->
                    <FormKit
                        type="checkbox"
                        name="status"
                        label="Show archived"
                        decorator-icon="checkedIcon"
                        outer-class="search-archived-label"
                        wrapper-class="mb-0"
                        inner-class=""
                        decorator-icon-class="!bg-white"
                    />
                </div>
                <div :class="['tabs_content', currentTab === 'all' ? 'active' : '']">
                    <div
                        ref="scrollContainerAll"
                        class="overflow-y-auto max-h-[calc(100vh-195px)]"
                        @scroll="handleScroll"
                    >
                        <p class="text-xs text-gray-300 uppercase font-medium mb-6">
                            <fa :icon="['fal', 'clock']" class="mr-1" /> Recent Contacts
                        </p>
                        <AppSearchContacts />

                        <!-- <div
                            v-for="(item, index) in processedArray"
                            :key="index"
                        >
                            <template
                                v-for="(data, dataIndex) in item.all"
                                :key="dataIndex"
                            >
                                <template v-if="data.contact_group_id">
                                    <app-search-contacts
                                        :dataObject="data"
                                        @contactLogs="searchLogsMethod"
                                    />
                                </template>
                                <template v-else-if="data.diary_id">
                                    <app-search-diary
                                        :dataObject="data"
                                        @contactLogs="searchLogsMethod"
                                    />
                                </template>
                                <template v-else-if="data.property_id">
                                    <app-search-properties
                                        :dataObject="data"
                                        @contactLogs="searchLogsMethod"
                                    />
                                </template>
                            </template>
                        </div> -->
                        <p class="text-xs text-gray-300 uppercase mt-8 font-medium mb-6">
                            <fa :icon="['fal', 'clock']" class="mr-1" /> Recent Properties
                        </p>
                        <AppSearchProperties />
                    </div>
                </div>
                <div :class="['tabs_content', currentTab === 'diary' ? 'active' : '']">
                    <div class="item_wrapper mb-4 justify-center max-h-[calc(100vh-230px)]">
                        <div class="filters_search flex mb-4">
                            <div class="fiter_item mr-2">
                                <AppSearchAutocomplete
                                    id="diaryevents"
                                    ref="diaryEvents"
                                    :events-array="searchFilterDataArray.events"
                                    filter-text="Suggestions"
                                    input-holder="Type"
                                    search-placeholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                />
                            </div>
                            <div class="fiter_item">
                                <AppSearchFilter
                                    id="diarystatus"
                                    ref="diaryStatus"
                                    :events-array="searchFilterDataArray.status"
                                    is-close=""
                                    filter-text="Status"
                                    input-holder="Status"
                                    @check-status-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                />
                            </div>
                            <div class="fiter_item mr-2">
                                <AppSearchAutocomplete
                                    id="diarylabels"
                                    ref="diaryLabels"
                                    :events-array="searchFilterDataArray.labels"
                                    filter-text="Suggestions"
                                    input-holder="Labels"
                                    search-placeholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                />
                            </div>
                            <div class="fiter_item mr-2">
                                <AppSearchAutocomplete
                                    id="diaryusers"
                                    ref="diaryUsers"
                                    :events-array="searchFilterDataArray.users"
                                    filter-text="Suggestions"
                                    input-holder="Assigned To"
                                    search-placeholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                />
                            </div>
                            <button
                                v-if="
                                    filterObj[currentTab] &&
                                    filterObj[currentTab].checkedItems &&
                                    filterObj[currentTab].checkedItems.length > 0
                                "
                                class="rounded-full border border-gray-200 bg-white dark:bg-gray-500 dark:text-white dark:border-black-900 flex items-center h-auto px-3 py-[0.4375rem] text-sm text-gray-300"
                                @click="clearAllFiltersMethod"
                            >
                                <span>Clear all</span>
                                <fa class="ml-3" :icon="['fal', 'times']" />
                            </button>
                        </div>
                        <div
                            ref="scrollContainerDiary"
                            class="overflow-y-auto max-h-[calc(100vh-250px)]"
                            @scroll="handleScroll"
                        >
                            <p class="text-xs text-gray-300 font-medium mb-4">
                                <fa :icon="['fal', 'clock']" class="mr-1" />
                                <span>Recent searches</span>
                            </p>
                            <AppSearchDiary />
                            <!-- <template
                                v-for="(data, dataIndex) in processedArray"
                                :key="dataIndex"
                            >
                                <template v-if="data.diary">
                                    <template
                                        v-for="(
                                            diaryData, diaryDataIndex
                                        ) in data.diary"
                                        :key="diaryDataIndex"
                                    >
                                        <app-search-diary
                                            :dataObject="diaryData"
                                            @diaryLogs="searchLogsMethod"
                                        />
                                    </template>
                                </template>
                            </template> -->
                        </div>
                    </div>
                </div>
                <div :class="['tabs_content', currentTab === 'inbox' ? 'active' : '']">
                    <p class="text-xs text-gray-300 font-medium mb-4">
                        <fa :icon="['fal', 'clock']" class="mr-1" /> Recent searches
                    </p>
                    <div
                        ref="scrollContainerInbox"
                        class="overflow-y-auto max-h-[calc(100vh-250px)]"
                        @scroll="handleScroll"
                    ></div>
                </div>
                <div :class="['tabs_content', currentTab === 'timeline' ? 'active' : '']">
                    <p class="text-xs text-gray-300 font-medium mb-4">
                        <fa :icon="['fal', 'clock']" class="mr-1" /> Recent searches
                    </p>
                    <div
                        ref="scrollContainerTimeline"
                        class="overflow-y-auto max-h-[calc(100vh-250px)]"
                        @scroll="handleScroll"
                    ></div>
                </div>
                <div :class="['tabs_content', currentTab === 'contact' ? 'active' : '']">
                    <div class="item_wrapper mb-4 justify-center">
                        <!-- <div class="filters_search flex mb-4">
                            <div class="fiter_item mr-2">
                                <app-search-autocomplete
                                    :eventsArray="searchFilterDataArray.boards"
                                    id="contacttype"
                                    filterText="Suggestions"
                                    inputHolder="Contact board"
                                    searchPlaceholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                    ref="contactBoard"
                                />
                            </div>
                            <div class="fiter_item mr-2">
                                <app-search-autocomplete
                                    :eventsArray="searchFilterDataArray.labels"
                                    id="contactlabels"
                                    filterText="Suggestions"
                                    inputHolder="Labels"
                                    searchPlaceholder="Search event types"
                                    ref="contactLabels"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                />
                            </div>
                            <div class="fiter_item mr-2">
                                <app-search-autocomplete
                                    :eventsArray="searchFilterDataArray.users"
                                    id="contactusers"
                                    filterText="Suggestions"
                                    inputHolder="Assigned to"
                                    searchPlaceholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                    ref="contactUsers"
                                />
                            </div>
                            <button
                                @click="clearAllFiltersMethod"
                                class="rounded-full border border-gray-200 bg-white dark:bg-gray-500 dark:text-white dark:border-black-900 flex items-center h-auto px-3 py-[0.4375rem] text-sm text-gray-300"
                                v-if="
                                    filterObj[currentTab] &&
                                    filterObj[currentTab].checkedItems &&
                                    filterObj[currentTab].checkedItems.length > 0
                                "
                            >
                                <span>Clear all</span>
                                <fa class="ml-3" :icon="['fal', 'times']"></fa>
                            </button>
                        </div> -->
                        <div
                            ref="scrollContainerContact"
                            class="overflow-y-auto max-h-[calc(100vh-195px)]"
                            @scroll="handleScroll"
                        >
                            <p class="text-xs text-gray-200 font-medium mb-6">
                                <fa :icon="['fal', 'clock']" class="mr-1" />
                                RECENT CONTACTS
                            </p>
                            <AppSearchContacts />
                            <!-- <template
                                v-for="(data, dataIndex) in processedArray"
                                :key="dataIndex"
                            >
                                <template v-if="data.contact">
                                    <template
                                        v-for="(
                                            contactData, contactDataIndex
                                        ) in data.contact"
                                        :key="contactDataIndex"
                                    >
                                        <app-search-contacts
                                            :dataObject="contactData"
                                            @contactLogs="searchLogsMethod"
                                        />
                                    </template>
                                </template>
                            </template> -->
                        </div>
                    </div>
                </div>
                <div :class="['tabs_content', currentTab === 'property' ? 'active' : '']">
                    <div class="item_wrapper mb-4 justify-center">
                        <!-- <div class="filters_search flex mb-4">
                            <div class="fiter_item mr-2">
                                <app-search-autocomplete
                                    :eventsArray="searchFilterDataArray.boards"
                                    id="propertytype"
                                    filterText="Suggestions"
                                    inputHolder="Property board"
                                    searchPlaceholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                    ref="propertyBoard"
                                />
                            </div>
                            <div class="fiter_item mr-2">
                                <app-search-autocomplete
                                    :eventsArray="searchFilterDataArray.labels"
                                    id="propertylabels"
                                    filterText="Suggestions"
                                    inputHolder="Labels"
                                    searchPlaceholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                    ref="propertyLabels"
                                />
                            </div>
                            <div class="fiter_item mr-2">
                                <app-search-autocomplete
                                    :eventsArray="searchFilterDataArray.users"
                                    id="propertyusers"
                                    filterText="Suggestions"
                                    inputHolder="Assigned to"
                                    searchPlaceholder="Search event types"
                                    @check-label-value="checkValueMethod"
                                    @un-check-label-value="uncheckValueMethod"
                                    ref="propertyUsers"
                                />
                            </div>
                            <button
                                @click="clearAllFiltersMethod"
                                class="rounded-full border border-gray-200 bg-white dark:bg-gray-500 dark:text-white dark:border-black-900 flex items-center h-auto px-3 py-[0.4375rem] text-sm text-gray-300"
                                v-if="
                                    filterObj[currentTab] &&
                                    filterObj[currentTab].checkedItems &&
                                    filterObj[currentTab].checkedItems.length > 0
                                "
                            >
                                <span>Clear all</span>
                                <fa class="ml-3" :icon="['fal', 'times']"></fa>
                            </button>
                        </div> -->
                        <div
                            ref="scrollContainerProperty"
                            class="overflow-y-auto max-h-[calc(100vh-250px)]"
                            @scroll="handleScroll"
                        >
                            <p class="text-xs text-gray-200 font-bold uppercase mb-6">
                                <fa :icon="['fal', 'clock']" class="mr-1" />
                                RECENT PROPERTIES
                            </p>
                            <AppSearchProperties />
                            <!-- <template
                                v-for="(data, dataIndex) in processedArray"
                                :key="dataIndex"
                            >
                                <template v-if="data.property">
                                    <template
                                        v-for="(
                                            propertyData, propertyDataIndex
                                        ) in data.property"
                                        :key="propertyDataIndex"
                                    >
                                        <app-search-properties
                                            :dataObject="propertyData"
                                            @propertyLogs="searchLogsMethod"
                                        />
                                    </template>
                                </template>
                            </template> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick, watch, onMounted, onUnmounted } from "vue";
import Tabs from "../tabber/Tabs.vue";
import AppSearchFilter from "./AppSearchFilter.vue";
import AppSearchAutocomplete from "./AppSearchAutocomplete.vue";
import AppSearchContacts from "@/components/smartSearch/AppSearchTabs/AppSearchContacts.vue";
import AppSearchProperties from "@/components/smartSearch/AppSearchTabs/AppSearchProperties.vue";
import AppSearchDiary from "@/components/smartSearch/AppSearchTabs/AppSearchDiary.vue";
import { searchLogs } from "@/api/AppSearch";
import { useAppSearchStore } from "@/stores/appSearchStore";
import { storeToRefs } from "pinia";
import { useOnClickOutside } from "@/composables/onClickOutside";
import { getUserImage, useScreenSize } from "@/composables/globals";
const searchDropdown = ref(null);
const isDesktop = useScreenSize();

useOnClickOutside(searchDropdown, () => {
    dropSearch.value = false;
});
const globalSearchInput = ref(null);
// search store
const searchStore = useAppSearchStore();
const {
    searchDataArray,
    searchTabsArray,
    appSearchString,
    currentTab,
    filterObj,
    searchFilterDataArray,
    pagination,
    totalPages,
} = storeToRefs(searchStore);

const { getResult, getFilterResult } = searchStore;

const handleClick = async (newTab) => {
    // searchDataArray.value = [];
    // pagination.value = 1;
    console.log(newTab, "new tab");
    currentTab.value = newTab;
    filterObj.value.active = newTab;
    await getResult(true);
    await getFilterResult();
};
const dropSearch = ref(false);
const openSearchMethod = () => {
    dropSearch.value = true;
    nextTick(async () => {
        globalSearchInput.value.focus();
        await getResult(true);
        await getFilterResult();
    });
    console.log(dropSearch.value, "dropSearch method");
};
const closeSearchMethod = () => {
    dropSearch.value = false;
};
const clearSearch = () => {
    searchStore.$reset();
    console.log("click on clearSearch");
};

// Function to highlight character
let highlightCharacter = (text) => {
    const re = new RegExp(appSearchString.value.toLowerCase(), "gi");
    return text.replace(re, (match) => `<mark>${match}</mark>`);
};
// Processed array
let processedArray = computed(() => {
    return JSON.parse(JSON.stringify(searchDataArray.value), (key, val) => {
        if (key == "badge" || key == "color" || key == "diary_date_query") {
            return val;
        } else {
            return typeof val === "string" ? highlightCharacter(val) : val;
        }
    });
});

const resetFilter = () => {
    for (let key in filterObj.value[currentTab.value]) {
        if (Array.isArray(filterObj.value[currentTab.value])) {
            filterObj.value[currentTab.value][key] = [];
        }
        // Check if filterObj[currentTab.value][key] is a string
        else if (typeof filterObj.value[currentTab.value][key] === "string") {
            filterObj.value[currentTab.value][key] = "";
        }
    }
};

const handleFilterObj = (array, filterObject, mode, reset) => {
    array.forEach((item) => {
        for (const key in item) {
            if (Object.prototype.hasOwnProperty.call(filterObject[currentTab.value], key)) {
                if (item[key] !== "" && item[key] !== null && item[key] !== undefined) {
                    // Check if filterObj[currentTab.value][key] is an array
                    if (Array.isArray(filterObject[currentTab.value][key])) {
                        const idValue = item.id || item.event_id || item.label_id || item.user_id;
                        const index = filterObject[currentTab.value][key].indexOf(idValue);

                        if (mode === "assign" && index === -1) {
                            filterObject[currentTab.value][key].push(idValue);
                        } else if (mode === "unassign" && index > -1) {
                            filterObject[currentTab.value][key].splice(index, 1);
                        }

                        if (reset) {
                            filterObject[currentTab.value][key] = [];
                        }
                    }
                    // Check if filterObj[currentTab.value][key] is a string
                    else if (typeof filterObject[currentTab.value][key] === "string") {
                        if (mode === "assign") {
                            filterObject[currentTab.value][key] = item[key];
                        } else if (mode === "unassign") {
                            filterObject[currentTab.value][key] = "";
                        }
                    }
                }
            }
        }
    });
};

const objectToQueryString = (obj) => {
    // debugger;
    let result = [];
    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            // Check if the value is an array
            if (Array.isArray(obj[key]) && obj[key].length > 0 && key !== "checkedItems") {
                result.push(`${key}=${obj[key].join(",")}`);
            } else if (typeof obj[key] === "string" && obj[key].length > 0 && key !== "checkedItems") {
                result.push(`${key}=${obj[key]}`);
            }
        }
    }
    return result.length > 0 ? "&" + result.join("&") : "";
};

const additionalParams = (obj) => {
    handleFilterObj(obj, filterObj.value, "assign", false);
    let additionalParams = objectToQueryString(filterObj.value[currentTab.value]);
    // let url = additionalParams;
    filterObj.value[currentTab.value].additionalUrl = additionalParams;
    return filterObj.value[currentTab.value].additionalUrl;
};

// Use the function
const checkValueMethod = async (value) => {
    resetFilter();
    filterObj.value[currentTab.value].additionalUrl = additionalParams(value);
    console.log(value, "checkValueMethod");
    await getResult(true);
    await getFilterResult();
};

const uncheckValueMethod = async (value) => {
    console.log(value, "uncheckValueMethod");
    let array = [];
    array = [];
    array.push(value);
    resetFilter();
    handleFilterObj(array, filterObj.value, "unassign", false);
    let additionalParams = objectToQueryString(filterObj.value[currentTab.value]);
    // let url = additionalParams;
    filterObj.value[currentTab.value].additionalUrl = additionalParams;
    await getFilterResult();
    await getResult(true);
    // then proceed to other operations like updating the additionalUrl
    // ...
};

// contact logs methods
const searchLogsMethod = async (value) => {
    let payload = {};
    for (let key in value) {
        payload[key] = value[key];
    }
    try {
        await searchLogs(payload);
        dropSearch.value = false;
    } catch (e) {
        console.log(e);
    }
};

// scrollContainer refs
const scrollContainerAll = ref(null);
const scrollContainerDiary = ref(null);
const scrollContainerInbox = ref(null);
const scrollContainerTimeline = ref(null);
const scrollContainerContact = ref(null);
const scrollContainerProperty = ref(null);

// Method to load more data
const loadMore = async () => {
    pagination.value++; // Increase the page number
    try {
        await getResult(); // Fetch new data with current page
    } catch (e) {
        console.log(e);
    }
};

const handleScroll = (container) => {
    let element;
    switch (container) {
        case "scrollContainerAll":
            element = scrollContainerAll.value;
            break;
        case "scrollContainerDiary":
            element = scrollContainerDiary.value;
            break;
        case "scrollContainerInbox":
            element = scrollContainerInbox.value;
            break;
        case "scrollContainerTimeline":
            element = scrollContainerTimeline.value;
            break;
        case "scrollContainerContact":
            element = scrollContainerContact.value;
            break;
        case "scrollContainerProperty":
            element = scrollContainerProperty.value;
            break;
        default:
            return;
    }

    if (element.scrollTop + element.clientHeight >= element.scrollHeight && pagination.value != totalPages.value) {
        console.log(`Scrolled to bottom of ${container}`);
        loadMore();
        // your loadMore() function here
    }
};

onMounted(() => {
    scrollContainerAll.value.addEventListener("scroll", () => handleScroll("scrollContainerAll"));
    scrollContainerDiary.value.addEventListener("scroll", () => handleScroll("scrollContainerDiary"));
    scrollContainerInbox.value.addEventListener("scroll", () => handleScroll("scrollContainerInbox"));
    scrollContainerTimeline.value.addEventListener("scroll", () => handleScroll("scrollContainerTimeline"));
    scrollContainerContact.value.addEventListener("scroll", () => handleScroll("scrollContainerContact"));
    scrollContainerContact.value.addEventListener("scroll", () => handleScroll("scrollContainerContact"));
});

// onUnmounted(() => {
//     scrollContainerAll.value.removeEventListener('scroll', () =>
//         handleScroll('scrollContainerAll')
//     );
//     scrollContainerDiary.value.removeEventListener('scroll', () =>
//         handleScroll('scrollContainerDiary')
//     );
//     scrollContainerInbox.value.removeEventListener('scroll', () =>
//         handleScroll('scrollContainerInbox')
//     );
//     scrollContainerTimeline.value.removeEventListener('scroll', () =>
//         handleScroll('scrollContainerTimeline')
//     );
//     scrollContainerContact.value.removeEventListener('scroll', () =>
//         handleScroll('scrollContainerContact')
//     );
//     scrollContainerContact.value.removeEventListener('scroll', () =>
//         handleScroll('scrollContainerContact')
//     );
// });

// clear all filters
const contactBoard = ref(null);
const contactUsers = ref(null);
const contactLabels = ref(null);
const propertyBoard = ref(null);
const propertyUsers = ref(null);
const propertyLabels = ref(null);
const diaryEvents = ref(null);
const diaryStatus = ref(null);
const diaryUsers = ref(null);
const diaryLabels = ref(null);

const clearAllFiltersMethod = async () => {
    let boardRef, usersRef, labelsRef, statusRef;

    switch (currentTab.value) {
        case "contact":
            boardRef = contactBoard.value;
            usersRef = contactUsers.value;
            labelsRef = contactLabels.value;
            break;
        case "property":
            boardRef = propertyBoard.value;
            usersRef = propertyUsers.value;
            labelsRef = propertyLabels.value;
            break;
        case "diary":
            boardRef = diaryEvents.value;
            statusRef = diaryStatus.value;
            usersRef = diaryUsers.value;
            labelsRef = diaryLabels.value;
            break;
        default:
            break;
    }

    if (boardRef || usersRef || labelsRef || statusRef) {
        boardRef?.deselectAll();
        usersRef?.deselectAll();
        labelsRef?.deselectAll();
        statusRef?.deselectAll();

        filterObj.value[currentTab.value].additionalUrl = "";
        await Promise.all([getFilterResult(), getResult(true)]);
    }
};
</script>

<style scoped>
.search_input {
    background-image: url('data:image/svg+xml,<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.248 22.7344C24.5293 23.0156 24.5293 23.5312 24.248 23.8125C24.1074 23.9531 23.9199 24 23.7324 24C23.498 24 23.3105 23.9531 23.123 23.8125L16.5137 17.1562C14.7793 18.6562 12.5762 19.5 10.1855 19.5C4.8418 19.5 0.482422 15.1406 0.482422 9.75C0.482422 4.40625 4.79492 0 10.1855 0C15.5293 0 19.9355 4.40625 19.9355 9.75C19.9355 12.1875 19.0918 14.3906 17.5918 16.125L24.248 22.7344ZM10.2324 18C14.7793 18 18.4824 14.3438 18.4824 9.75C18.4824 5.20312 14.7793 1.5 10.2324 1.5C5.63867 1.5 1.98242 5.20312 1.98242 9.75C1.98242 14.2969 5.63867 18 10.2324 18Z" fill="%23BAC4CD"/></svg>');
    background-repeat: no-repeat;
    background-position: 0.6rem 13px;
    background-size: 18px;
}

.tabs_content {
    opacity: 0;
    visibility: hidden;
    width: 100%;
    flex-basis: 100%;
    flex: 0 0 100%;
    position: absolute;
    left: -100%;
    transition: all 0.25s ease-in-out;
    z-index: -1;
}

.tabs_content.active {
    opacity: 1;
    visibility: visible;
    position: static;
}
.item_inner {
    @apply hover:bg-gray-100 cursor-pointer;
}
.search-archived-label :deep(.formkit-label) {
    @apply text-gray-200;
}
.search_results_wrapper {
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
}
@media screen and (max-width: 767px) {
    .desktop_search_wrapper {
        display: none !important;
    }
}
</style>
